import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const numberMoreThan0Message = () => i18n.t("validation.numberGreaterThanZero", {ns: "common"});

export const poolMergeOptionsValidation = yup.object().shape({
    options: yup.object().shape({
        merge: yup.object().shape({
            level: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            name: yup.string().when("isActive", {
                is: true,
                then: yup.string().required(requiredMessage)
            }),
            poolRate: yup.number().when("isActive", {
                is: true,
                then: yup.number().required(requiredMessage)
            }),
            orderOnQueue: yup.number().when("isActive", {
                is: true,
                then: yup.number().required(requiredMessage)
            }),
            capacityRate: yup.number().when("isActive", {
                is: true,
                then: yup.number().required(requiredMessage)
            }),
            clickToDoorTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            prepTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            prepTimeBufferPercent: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            handOverTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            maxOrder: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            maxPickup: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            })
        })
    })
});
